import { fetchAccountsReceivableSummary } from '@/api/business/unsettledSecurities'
import { useQuery } from '@tanstack/react-query'

export const AccountsReceivableSummaryKeys = {
    all: ['accountsreceivablesummary'] as const,
    lists: () => [...AccountsReceivableSummaryKeys.all, 'list'] as const, 
}

export const useAccountsReceivableSummaryQuery = () => {
    return useQuery({
        queryFn: fetchAccountsReceivableSummary,
        queryKey: AccountsReceivableSummaryKeys.lists(),
    })
}
